/**
 * A list of support events to intercept.
 * @see https://github.com/fiverr/perimeterx-axios-interceptor
 * @type {Object<String>}
 */
export const INTERCEPTOR_EVENTS = {
    IGNORE: 'ignore',
    SUCCESS: 'success',
    FAILURE: 'failure',
    INTERCEPT: 'intercept'
};

/**
 * A mapping between an interceptor event type and its corresponding message.
 * @type {Object<String>}
 */
export const INTERCEPTOR_MESSAGES = {
    [INTERCEPTOR_EVENTS.IGNORE]: 'Axios ignored a PerimeterX block response',
    [INTERCEPTOR_EVENTS.SUCCESS]: 'Axios interceptor exonerated request',
    [INTERCEPTOR_EVENTS.INTERCEPT]: 'Axios intercepted a PerimeterX block response'
};

/**
 * Code field to log record.
 * @type {String}
 */
export const LOG_CODE = 'AXIOS_INTERCEPT_EVENT';

/**
 * URLs to ignore when intercepting.
 @type {RegExp}
 */
export const IGNORE_PATTERN = new RegExp(`^\\/${[
    '\\.well-known\\/',
    'js_event_tracking',
    'transmitter',
    'manifest\\.json',
    'tag_manager\\/fetch_events',
    'inbox\\/counters',
    'amiloggedin',
    'localization\\/detect_language'
].join('|')}`);
